import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { combineLatest, of } from 'rxjs';
import { catchError, groupBy, map, mergeMap, reduce, toArray } from 'rxjs/operators';
import { EventResource } from 'src/app/interfaces/event-resource';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { EventService } from 'src/app/services/event.service';
import { PartnerService } from 'src/app/services/partner.service';
import { StatsService } from 'src/app/services/stats.service';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { McpService } from 'src/app/services/mcp.service';
import { NavigationExtras, Router } from '@angular/router';
import { Configs } from './chart-configs'
import { BusinessEntityResource } from 'src/app/interfaces/business-entity-resource';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTableDataSource } from '@angular/material/table';/**
* The Options used for sorting
*/
interface SortOption {
 /**
  * The Value of the Filteroption
  */
 value: string;
 /**
  * The viewValue (visible to the User) of the Filteroption
  */
 viewValue: string;
 /**
  * Is the  Filteroption disabled
  */
 state: boolean;
}
/**
* The Object used to load GoogleCharts
*/
declare var google: any;
/**
 * @ignore
 */
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit ,AfterViewInit{
  @ViewChild('userChart') userChart: ElementRef;
  @ViewChild('savingsChart') savingsChart: ElementRef;
  @ViewChild('attendenceChart') attendenceChart: ElementRef;
  @ViewChild('donutchart_0') donutchart_0: ElementRef;
  @ViewChild('donutchart_1') donutchart_1: ElementRef;
  @ViewChild('donutchart_2') donutchart_2: ElementRef;
  @ViewChild('donutchart_0_flop') donutchart_0_flop: ElementRef;
  @ViewChild('donutchart_1_flop') donutchart_1_flop: ElementRef;
  @ViewChild('donutchart_2_flop') donutchart_2_flop: ElementRef;

;
  filterTestForm: UntypedFormGroup;
  public allEventsSortedBytotalActiveReservationsCount = [];
  public Image1: string;
  SubCustomerCount: number = 0;
  partnerCount$ = this.partnerService.partnerCount$;
  eventCount$ = this.eventService.eventCount$;
  alleventCount$ = this.eventService.alleventCount$;
  MainCustomerCount$ = this.businessuserService.MainCustomerCount$;

  public top1Event: EventResource = null;
  public top2Event: EventResource = null;
  public top3Event: EventResource = null;
  public flop1Event: EventResource = null;
  public flop2Event: EventResource = null;
  public flop3Event: EventResource = null;
  public events: SortOption[] = [];
  finishedLoadingFlopsAndTops: boolean = true;
  maxDate: Date = new Date();
  finishedLoadingTree: boolean = false;
  notEnoughEvents: boolean = false;
  heighCalender = "1600px;"

  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  showUserDataAsTable: boolean = false;
  clientConfig;


  data_donut_types = [];
  data_donut_eventLimits = [];
  data_donut_voucherStrats = [];

  config_donut_types = Configs.config_donut_types;
 
  data_radar = Configs.data_radar;
  options_radar = Configs.options_radar;
  options_line_simple = Configs.options_line_simple;
  options_line_partners = Configs.options_line_partners;
  options_line_savings = Configs.options_line_savings;
  tree_options = Configs.tree_options;
  treemap_options = Configs.treemap_options;
  config_donut_users = Configs.config_donut_users;
  options_line_year = Configs.options_line_year;
  options_word_cloud = Configs.options_word_cloud;
  options_line_reservations = Configs.options_line_reservations;
  options_bar_horizontal = Configs.options_bar_horizontal;



  data_interest = [];
  data_partners = [];
  data_savings = [];
  data_bar_horizontal = [];
  data_word_cloud = []
  treeData = [];

  myControl = new UntypedFormControl();
  filteredOptions = [];
  filteredOptions_2 = [];
  filteredOptions_3 = [];
  optionsAuto = [];
  allActiveEvents = [];

  finishedLoadingComparison: boolean = true;
  hasEventV2: boolean = true;
  hasEventV1: boolean = true;


  loading_bar_horizontal: boolean = true;
  config;
  allEvents: boolean = false;
  eventFilter = ['ACTIVE', 'HIDDEN']
  dataTemp = [];
  dataSourceReservations: MatTableDataSource<any>;
  displayedColumnsReservations = ['number', 'event', 'reservations'];

  constructor(
    private statsService: StatsService,
    private eventService: EventService,
    private partnerService: PartnerService,
    private fb: UntypedFormBuilder,
    private businessuserService: BusinessuserService,
    private router: Router,
    private mcp: McpService) {

    google.charts.load('current', { 'packages': ["calendar, corechart"], 'language': 'de' });
   
    this.filterTestForm = this.fb.group({
      serachForEvent: ["", [Validators.required]],
      serachForEvent_2: ["", [Validators.required]],
      serachForEvent_3: ["", [Validators.required]],
    })



  }


  ngAfterViewInit() {
    this.mcp.loadConfiguration().subscribe((val) => {
      this.clientConfig = val;
      this.drawChart();
    })

    this.partnerService.getPartners(0, 999).subscribe((partners: PagedResources<BusinessEntityResource>) => {
      partners.content.forEach((element, index) => {
        this.eventService.searchForEvents(0, 999, null, null, [`${element.publicId}`], null).subscribe((events: PagedResources<EventResource>) => {
          if (events.content.length != 0) {
            this.treeData.push({
              "name": element.name,
              "children": []
            })
            events.content.forEach(element => {
              this.treeData[this.treeData.length - 1].children.push({
                "name": element.title,
                "children": [],
              })
            });
          }
          this.treeData = [...this.treeData];
          this.finishedLoadingTree = true;
        })
      });
    })
  }

  ngOnInit() {
    this.finishedLoadingComparison = false;
    this.loading_bar_horizontal = true;
    this.businessuserService.SubCustomerCount$.subscribe(subCutomers => {
      this.SubCustomerCount = subCutomers
    });

    this.eventService.searchForEvents(0, 1, ['ARCHIVED'], null, null, null).subscribe((val: PagedResources<EventResource>) => {
      this.eventService.searchForEvents(0, val.page.totalElements, ['ARCHIVED'], null, null, null).subscribe((val: PagedResources<EventResource>) => {
        var date = new Date();
        date.setMonth(date.getMonth() - 12);
        date.setHours(0, 0, 0, 0)
        let t = val.content.filter(o => (new Date(o.endDate) >= date) && (new Date(o.endDate) < new Date()));
        t.forEach((event: EventResource, index) => {
          if (index <= 20) {
            this.data_bar_horizontal.push({
              group: event.title,
              value: event.totalActiveReservationsCount
            })      
          }
        });

        this.dataSourceReservations = new MatTableDataSource(t)
        this.data_bar_horizontal = [...this.data_bar_horizontal]
        this.loading_bar_horizontal = false;
      })
    })

    this.eventService.searchForEvents(0, 1, this.eventFilter, null, null, null).subscribe((val: PagedResources<EventResource>) => {
      this.eventService.searchForEvents(0, val.page.totalElements, this.eventFilter, null, null, null).subscribe((val: PagedResources<EventResource>) => {
        this.allActiveEvents = val.content;
        this.filteredOptions = val.content;
        this.filteredOptions_2 = val.content;
        this.filteredOptions_3 = val.content;
      })
    })
    let interestCount = [];
    let partnerCount = [];
    let eventTypes = [];
    this.eventService.searchForEvents(0, 1, this.eventFilter, null, null, null).subscribe((val: PagedResources<EventResource>) => {
      if (val.page.totalElements >= 1) {
        this.eventService.searchForEvents(0, val.page.totalElements, this.eventFilter, null, null, null).subscribe((val: PagedResources<EventResource>) => {
          val.content.forEach((element: EventResource, index) => {
            this.events.push({
              value: element?.publicId, viewValue: element?.title, state: false
            })
            partnerCount.push(element.eventPartner);
            eventTypes.push(element);
                });

          // const interestsByCount = interestCount.reduce((acc, value) => {
          //   // Group initialization
          //   if (!acc[value.name]) {
          //     acc[value.name] = [];
          //   }
          //   // Grouping
          //   acc[value.name].push(value);
          //   return acc;
          // }, {});

          const typesByCount = eventTypes.reduce((acc, value) => {
            // Group initialization
            if (!acc[value.eventDiscount]) {
              acc[value.eventDiscount] = [];
            }
            // Grouping
            acc[value.eventDiscount].push(value);
            return acc;
          }, {});

          const voucherStrategiesByCount = eventTypes.reduce((acc, value) => {
            // Group initialization
            if (!acc[value.voucherKeyStrategy]) {
              acc[value.voucherKeyStrategy] = [];
            }
            // Grouping
            acc[value.voucherKeyStrategy].push(value);
            return acc;
          }, {});


          const partnersByCount = partnerCount.reduce((acc, value) => {
            // Group initialization
            if (!acc[value.name]) {
              acc[value.name] = [];
            }
            // Grouping
            acc[value.name].push(value);
            return acc;
          }, {});

          const eventLimitByCount = eventTypes.reduce((acc, value) => {
            // Group initialization
            if (!acc[value.eventLimit]) {
              acc[value.eventLimit] = [];
            }
            // Grouping
            acc[value.eventLimit].push(value);
            return acc;
          }, {});

          const savingInPercentByCount = eventTypes.reduce((acc, value) => {
            // Group initialization
            if (!acc[value.savingInPercent]) {
              acc[value.savingInPercent] = [];
            }
            // Grouping
            acc[value.savingInPercent].push(value);
            return acc;
          }, {});

         Object.entries(savingInPercentByCount).forEach((element: any) => {
            this.data_savings.push({
              "group": element[0] + " %",
              "value": element[1].length
            })
          });

          let sum_savings = 0;
          this.data_savings.forEach(element => {
            sum_savings += element.value
          });

          Object.entries(partnersByCount).forEach((element: any) => {
            this.data_partners.push({
              "group": element[0],
              "value": element[1].length
            })
          });

          let sum_partners = 0;
          this.data_partners.forEach(element => {
            sum_partners += element.value
          });

          Object.entries(typesByCount).forEach((element: any) => {
            this.data_donut_types.push({
              "group": this.localeTranslateEventState(element[0]),
              "value": element[1].length
            })
          });

          Object.entries(eventLimitByCount).forEach((element: any) => {
            this.data_donut_eventLimits.push({
              "group": this.localeTranslateEventLimit(element[0]),
              "value": element[1].length
            })
          });

          Object.entries(voucherStrategiesByCount).forEach((element: any) => {
            this.data_donut_voucherStrats.push({
              "group": this.localeTranslateEventVoucherStrats(element[0]),
              "value": element[1].length
            })
          });

          this.data_partners = [...this.data_partners];
          this.data_interest = [...this.data_interest];
          this.data_donut_types = [...this.data_donut_types];
          this.data_donut_eventLimits = [...this.data_donut_eventLimits];
          this.data_donut_voucherStrats = [...this.data_donut_voucherStrats];
          this.data_savings = [...this.data_savings];
        })
      } else {

      }
    })
  }

  moveToEventWithFilter() {
    let navigationExtras: NavigationExtras = {
      state: {
        filterState: ['ACTIVE']
      }
    };
    this.router.navigate(['caseworker/event'], navigationExtras)
  }

  moveToPartnersWithFilter() {
    let navigationExtras: NavigationExtras = {
      state: {
        filterState: ['ACTIVE']
      }
    };
    this.router.navigate(['caseworker/businessentity'], navigationExtras)
  }

  //totalActiveReservationsCount
  drawChart = () => {
    this.eventService.getTopThreeEvents(this.eventFilter, null, null, null).pipe(
      catchError(err => of(err)),
    ).subscribe(allEventsSorted => {
      this.allEventsSortedBytotalActiveReservationsCount = allEventsSorted;
      if (allEventsSorted.length == 0) {
        this.notEnoughEvents = true;
      } else {
        if (allEventsSorted.length >= 1) {
          this.top1Event = allEventsSorted[0];
        }
        if (allEventsSorted.length >= 2) {
          this.top2Event = allEventsSorted[1];
        }
        if (allEventsSorted.length >= 3) {
          this.top3Event = allEventsSorted[2];
        }
        if (allEventsSorted.length >= 4) {
          this.flop1Event = allEventsSorted[allEventsSorted.length - 1];
        }
        if (allEventsSorted.length >= 5) {
          this.flop2Event = allEventsSorted[allEventsSorted.length - 2];
        }
        if (allEventsSorted.length >= 6) {
          this.flop3Event = allEventsSorted[allEventsSorted.length - 3];
        }
        if (allEventsSorted.length >= 3) {
          this.filterTestForm.patchValue({
            serachForEvent: this.top1Event.publicId,
            serachForEvent_2: this.top2Event.publicId,
            serachForEvent_3: this.top3Event.publicId,
          });
          this.filterEvents();
        }
      }
    })
    this.finishedLoadingComparison = false;
    this.finishedLoadingFlopsAndTops = false;
  }

  showAllEvents() {
    if (this.allEvents == true) {
      this.eventFilter = ["ACTIVE", "HIDDEN", "EXPIRED", "ARCHIVED"];
    } else {
      this.eventFilter = ["ACTIVE", 'HIDDEN'];
    }
    this.finishedLoadingFlopsAndTops = true;
    // this.data_donut_1 = [];
    // this.data_donut_2 = [];
    // this.data_donut_3 = [];
    // this.data_donut_1_flop = [];
    // this.data_donut_2_flop = [];
    // this.data_donut_3_flop = [];
    this.data_partners = [];
    this.data_interest = [];
    this.data_donut_types = [];
    this.data_donut_eventLimits = [];
    this.data_donut_voucherStrats = [];
    this.data_savings = [];
    this.events = [];
    // this.treeData = [];
    this.data_word_cloud = [];
   // this.data_reservations_line = [];

    this.top1Event = null;
    this.top2Event = null;
    this.top3Event = null;


    this.ngOnInit();
    this.filterEvents();
    this.drawChart();

  }








  toggleUsersToggle(e: MatSlideToggleChange) {
    this.showUserDataAsTable = e.checked;
    if (e.checked == false) {
      this.drawChart();
    }
  }

  filterEvents() {
    if (this.filterTestForm.invalid) {
      return
    }
    this.finishedLoadingComparison = false;
    this.data_radar = [];
    combineLatest([
      this.eventService.getEventV1(this.filterTestForm.value.serachForEvent).pipe(
        catchError(err => of(err)),
      ),
      this.eventService.getEventV1(this.filterTestForm.value.serachForEvent_2).pipe(
        catchError(err => of(err)),
      ),
      this.eventService.getEventV1(this.filterTestForm.value.serachForEvent_3).pipe(
        catchError(err => of(err)),
      ),
    ]).pipe(
      map(([event_1, event_2, event_3]) => {
        this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], event_1?.publicId).subscribe((value: PagedResources<any>) => {
          this.data_radar.push(

            {
              "group": event_1.title,
              "key": "Reservierungen",
              "value": event_1.totalActiveReservationsCount
            },
            {
              "group": event_1.title,
              "key": "eingelöst",
              "value": value.page.totalElements
            },
            {
              "group": event_1.title,
              "key": "Nicht eingelöst",
              "value": event_1.totalActiveReservationsCount - value.page.totalElements
            }
          )
          this.data_radar = [...this.data_radar];
        })

        this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], event_2?.publicId).subscribe((value: PagedResources<any>) => {
          this.data_radar.push(

            {
              "group": event_2.title,
              "key": "Reservierungen",
              "value": event_2.totalActiveReservationsCount
            },
            {
              "group": event_2.title,
              "key": "eingelöst",
              "value": value.page?.totalElements
            },
            {
              "group": event_2.title,
              "key": "Nicht eingelöst",
              "value": event_2.totalActiveReservationsCount - value.page.totalElements
            }
          )
          this.data_radar = [...this.data_radar];
        })

        this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], event_3?.publicId).subscribe((value: PagedResources<any>) => {
          this.data_radar.push(

            {
              "group": event_3.title,
              "key": "Reservierungen",
              "value": event_3.totalActiveReservationsCount
            },
            {
              "group": event_3.title,
              "key": "eingelöst",
              "value": value.page?.totalElements
            },
            {
              "group": event_3.title,
              "key": "Nicht eingelöst",
              "value": event_3.totalActiveReservationsCount - value.page.totalElements
            }
          )
          this.data_radar = [...this.data_radar];
        })
      })
    ).subscribe(val => {
      this.finishedLoadingComparison = true;
    })

  }

  localeTranslateEventState(event) {
    switch (event) {
      case "EXTERNAL_EVENT":
        return "Partneraktion";
      case "RAFFLE":
        return "Gewinnspiel";
      case "SERVICE_PLUS":
        return "Exklusiv";
      case "MONETARY":
        return "Preisvorteil";
      default:
        return event;
    }
  }

  localeTranslateEventLimit(limit) {
    switch (limit) {
      case "WITHOUT_LIMIT":
        return "Ohne Einschränkung";
      case "ADULT":
        return "Erwachsene (>= 18 Jahre)";
      case "YOUTH":
        return "unter 18-jährige";
      case "CHILDREN":
        return "Kinder (6-12 Jahre)";
      case "CHILDREN2":
        return "Kinder 2 (8-14 Jahre)";
      case "WOMAN_ONLY":
        return "Frauen (>=18 Jahre)";
      case "MAN_ONLY":
        return "Männer (>= 18 Jahre)";
      case "TEENAGER":
        return "Jugendliche (13-17 Jahre)";
      case "BABYS":
        return "Kleinkinder (0-5 Jahre)";
      default:
        return limit;
    }
  }

  localeTranslateEventVoucherStrats(limit) {
    switch (limit) {
      case "GATES":
        return "Gates Gutscheincodes";
      case "EXTERNAL_SINGLE_KEY":
        return "Aktionspartnercodes (einer)";
      case "EXTERNAL_KEY_LIST":
        return "Aktionspartnercodes (mehrere)";
      default:
        return limit;
    }
  }
}
